// Кнопка «Скопировать» в блоке реквизитов: собирает строки с data-requisites-line
// и кладёт их в буфер обмена, на 2 секунды меняя подпись кнопки на «Скопировано».
document.addEventListener('DOMContentLoaded', function () {
  const button = document.querySelector('#requisites-copy-button');
  if (!button) return;

  const label = button.querySelector('span');
  const defaultText = label.textContent;
  const copiedText = button.dataset.copiedText || defaultText;
  let resetTimer = null;

  function getRequisitesText() {
    return Array.from(document.querySelectorAll('[data-requisites-line]'))
      .map((line) => line.textContent.replace(/\s+/g, ' ').trim())
      .filter(Boolean)
      .join('\n');
  }

  function fallbackCopy(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      document.execCommand('copy');
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function showCopied() {
    label.textContent = copiedText;
    button.classList.add('copied');
    clearTimeout(resetTimer);
    resetTimer = setTimeout(function () {
      label.textContent = defaultText;
      button.classList.remove('copied');
    }, 2000);
  }

  button.addEventListener('click', function () {
    const text = getRequisitesText();

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(showCopied, function () {
        fallbackCopy(text);
        showCopied();
      });
    } else {
      fallbackCopy(text);
      showCopied();
    }
  });
});
